// A formula da Mavalerio, decifrada celula a celula em 01/09/2026 (ramo
// normal -- o ramo do Amapa em Area de Livre Comercio nao e implementado,
// nao ha cliente real nesse caso hoje). Ver a spec para a deducao completa.
//
// precoFinal = base + ST (so se houver MVA) + IPI
// base = precoSemImposto / ((1-ICMS_origem) x (1-PIS/COFINS))
//        x (1-descontoEntrega) x (1-descontoPrazo)
// ST = base x (1+MVA) x (1+IPI) x ICMS_interno_destino
//    - base x MENOR(ICMS_origem, ICMS_interno_destino)
export interface EntradaImposto {
  precoSemImposto: number
  icmsOrigemPct: number
  icmsInternoDestinoPct: number
  pisCofinsPct: number
  ipiPct: number
  mvaStPct: number
  descontoEntregaPct: number
  descontoPrazoPct: number
}

// ⚠⚠ ATUALIZADO 14/10/2026 (palavra dela): `precoFinal` NAO e mais o preco de
// venda -- o valor do pedido e o preco da tabela, e o imposto (ipi, diferencaIcms)
// e so INFORMATIVO, mostrado ao cliente. Os campos abaixo seguem corretos como
// CALCULO; so mudou o que o pedido faz com eles (ver pedidos/carrinho.ts).
//
// (Historico, 09/09:) regra de "o que o cliente paga", cruzada contra 3 pedidos
// REAIS dela (2026-0052 Acucar Colorido Amarelo, 2026-0053 Acucar
// Confeiteiro, e o multi-marca 2026-0045 inteiro com Mavalerio+Oetker):
// `precoFinal` (= destinoIcms + ipi) e SEMPRE o preco cobrado. Nunca "so
// origem", nunca "so ate o ICMS ST" -- os dois impostos sao cobranca real:
// ICMS ST (quando ha ST de verdade, mva_pct cadastrado) e recolhimento
// antecipado por Substituicao Tributaria, por lei; IPI e imposto federal
// SEMPRE destacado na nota, nunca "so referencia". Esta interface passou por
// 3 revisoes no mesmo dia (origem-so -> destinoIcms-so -> precoFinal) -- se
// mexer aqui de novo, testar contra os 3 pedidos acima antes de mudar
// `carrinho.ts`.
export interface ComposicaoImposto {
  // Preco com PIS/COFINS/ICMS de ORIGEM embutidos -- ainda sem ST nem IPI.
  // NAO e o preco cobrado (ver precoFinal).
  origem: number
  // origem + a diferenca de ICMS -- so a parte do ICMS, nunca o IPI dentro.
  destinoIcms: number
  // A parte SO do ICMS que a diferenca acima soma -- so existe quando ha ST
  // de verdade (mva_pct > 0). Cobranca real: recolhimento antecipado por
  // Substituicao Tributaria.
  diferencaIcms: number
  // Imposto federal SEMPRE destacado na nota -- cobranca real, nao referencia.
  ipi: number
  // destinoIcms + ipi -- NAO e o preco de venda (ver nota acima); so informativo.
  precoFinal: number
}

function fracao(pct: number): number {
  return pct / 100
}

export function calcularImposto(entrada: EntradaImposto): ComposicaoImposto {
  const {
    precoSemImposto, icmsOrigemPct, icmsInternoDestinoPct, pisCofinsPct,
    ipiPct, mvaStPct, descontoEntregaPct, descontoPrazoPct,
  } = entrada

  const base =
    (precoSemImposto / ((1 - fracao(icmsOrigemPct)) * (1 - fracao(pisCofinsPct))))
    * (1 - fracao(descontoEntregaPct))
    * (1 - fracao(descontoPrazoPct))

  const temSt = mvaStPct > 0
  const diferencaIcms = temSt
    ? base * (1 + fracao(mvaStPct)) * (1 + fracao(ipiPct)) * fracao(icmsInternoDestinoPct)
      - base * fracao(Math.min(icmsOrigemPct, icmsInternoDestinoPct))
    : 0

  const ipi = base * fracao(ipiPct)
  const destinoIcms = base + diferencaIcms

  return {
    origem: base,
    destinoIcms,
    diferencaIcms,
    ipi,
    precoFinal: destinoIcms + ipi,
  }
}
